module.exports = __webpack_public_path__ + "img/photo.1a20d4b7.png";